module.exports = __webpack_public_path__ + "static/media/ImageGreen.3dcea4f4.svg";